import { BCMSRecord, DisabledPrompt, Link, useGlobalController, useRoute } from "bcms-react";
import { UIRadio } from 'components/custom-ui/UIRadioGroup';
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import { PrimaryButton, SecondaryButton, UICheckbox } from 'components/ui';
import UIPhoneNumberInput from 'components/ui/UIPhoneNumberInput';
import { User } from "model";
import React from 'react';
import "./mobile.css";
import "./styles.css";

/**
 * @function TextBankingPage
 * @return {React.Component}
 * @exported true
 * @description The main component for TextBankingPage
 */
export default function TextBankingPage(props) {
  const navigate = useRoute();
  const controller = useGlobalController();
  BCMSRecord.globalControllerFor([ User ], controller);
  const user = User.init(controller.state.user);

  return (
    <PageContainer className="text-banking-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Register Phone Number" />
          <div className="content-container">
            <p>Access your accounts on the go. Sign up below and send a text message to see it work. Please see Help for a list of available commands.</p>
            <p>1 message/request, the message frequency varies per user if the user subscribes to alerts. Message and Data Rates may apply.</p>
            <p>Send STOP to cancel or HELP to get information.</p>
          </div>
          <FormContainer className="small-form-width">
            <FormRowView className="ui-radio-view">
              <UIRadio name="phone-number" checked={true} label={ `Use the mobile number on file: ${ user.phone.value }` } />
            </FormRowView>
            <FormRowView className="ui-radio-view">
              <UIRadio name="phone-number" label="Enter a new mobile phone for Text Banking." />
            </FormRowView>
            <FormRowView text="*Enter Phone Number">
              <UIPhoneNumberInput />
            </FormRowView>
            <FormRowView text="*Re-enter Phone Number">
              <UIPhoneNumberInput />
            </FormRowView>
            <FormRowView className="ui-check-box-view">
              <UICheckbox label={<span>I agree with the <DisabledPrompt><Link>Terms and Conditions </Link></DisabledPrompt> and the <DisabledPrompt><Link>Privacy Policy</Link></DisabledPrompt></span>} />
            </FormRowView>
            <FormButtonRow>
              <SecondaryButton text="Cancel" onClick={() => {navigate("/settingsMenu")}}/>
              <DisabledPrompt>
                <PrimaryButton text="Add" />
              </DisabledPrompt>
            </FormButtonRow>
          </FormContainer>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
